import React, { useState } from 'react';
import { Badge } from './ui/badge';
import { Card, CardContent } from './ui/card';
import { Skills } from '../data/Data';

const SkillsSection = () => {
  const scrollToContact = () => {
    document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
  };

  const [selectedCategory, setSelectedCategory] = useState(null);

  return (
    <section id="skills" className="py-20 bg-gradient-to-b from-black via-slate-900 to-black relative">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black mb-4">
            <span className="bg-gradient-to-r from-red-400 to-red-600 bg-clip-text text-transparent">
              SPECIAL
            </span>
            <br />
            <span className="bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
              SKILLS
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            The stack of technologies and skills I can use to bring ideas to life.
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Skills.map((skillCategory, index) => (
            <Card 
              key={index}
              className="bg-gray-800/50 border-gray-700 hover:border-red-500/50 transition-all duration-500 cursor-pointer backdrop-blur-sm group"
              onClick={() => setSelectedCategory(selectedCategory === index ? null : index)}
            >
              <CardContent className="p-6">
                {/* Category Header */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="text-3xl">{skillCategory.icon}</div>
                    <h3 className="text-lg font-bold text-white group-hover:text-red-400 transition-colors">
                      {skillCategory.category}
                    </h3>
                  </div>
                  <Badge variant="outline" className="bg-red-500/20 text-red-300 border-red-500/50">
                    {skillCategory.skills.length}
                  </Badge>
                </div>

                {/* Skills Preview */}
                <div className="space-y-2">
                  {skillCategory.skills.slice(0, 3).map((skill, skillIndex) => (
                    <div 
                      key={skillIndex}
                      className="flex items-center space-x-2 p-2 bg-gray-700/30 rounded-md"
                    >
                      <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                      <span className="text-gray-300 text-sm">{skill}</span>
                    </div>
                  ))}
                  
                  {skillCategory.skills.length > 3 && (
                    <div className="text-center pt-2">
                      <button className="text-red-400 text-sm hover:text-red-300 transition-colors">
                        +{skillCategory.skills.length - 3} more
                      </button>
                    </div>
                  )}
                </div>

                {/* Expanded View */}
                {selectedCategory === index && (
                  <div className="mt-4 pt-4 border-t border-gray-700">
                    <div className="flex flex-wrap gap-2">
                      {skillCategory.skills.map((skill, skillIndex) => (
                        <Badge 
                          key={skillIndex}
                          variant="secondary"
                          className="bg-red-500/20 text-red-300 hover:bg-red-500/30 transition-colors"
                        >
                          {skill}
                        </Badge>
                      ))}
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Skill Level Legend */}
        {/* <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-8 p-6 bg-gray-800/30 rounded-lg backdrop-blur-sm">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="text-gray-300 text-sm">Advanced</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-amber-500 rounded-full"></div>
              <span className="text-gray-300 text-sm">Intermediate</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span className="text-gray-300 text-sm">Beginner</span>
            </div>
          </div>
        </div> */}

        {/* Call to Action */}
        <div className="text-center mt-12">
          <h3 className="text-2xl font-bold text-white mb-4">Ready for Your Next Project?</h3>
          <p className="text-gray-400 mb-6">Let's create something extraordinary together</p>
          <button
          onClick={scrollToContact}
          className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-semibold px-8 py-3 rounded-md transition-all duration-300 transform hover:scale-105">
            Start a New Production
          </button>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;